import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { StatisticComponent } from './statistic.component';
import { StatisticGroupComponent } from './statistic-group.component';

@NgModule({
    imports: [CommonModule, NzStatisticModule, NzEmptyModule, NzSkeletonModule],
    declarations: [StatisticGroupComponent, StatisticComponent],
    exports: [StatisticGroupComponent, StatisticComponent],
})
export class VisualizationModule {}
